import { Dropdown, Flex, Tooltip } from "antd";
import { CopyOutlined, EditOutlined, DeleteOutlined, MoreOutlined } from '@ant-design/icons';
import './JobAdCard.css'
import moment from 'moment';
import iconRename from '../../icons/icon-rename.svg';


function JobAdCard({ title, subTitle, id, date, actionsHandler, clickCardHandler, showMenu }) {

    const items = [
        {
            key: 'rename',
            icon: <img src={iconRename} alt="rename" className="jobadcard-rename-icon" />,
            label: 'Rename',
        },
        {
            key: 'duplicate',
            icon: <CopyOutlined />,
            label: 'Duplicate',
        }
        ,
        {
            key: 'edit',
            icon: <EditOutlined />,
            label: 'Edit',
        },
        {
            key: 'delete',
            icon: <DeleteOutlined />,
            label: 'Delete',
        }
    ];

    const onClickDropdown = (e) => {
        e.stopPropagation();
    }

    const onClickCard = (e) => {
        clickCardHandler();
    }

    const menuClicked = (event) => {
        event.domEvent.stopPropagation();
        actionsHandler({
            action: event.key,
            id
        });
    };

    return (
        <div className='jobad-card-container' onClick={(e) => onClickCard(e)}>
            <div className="jobad-card-content">
                <Flex justify='space-between' gap={12} >
                    <div className='jobad-card-title'>
                        <Tooltip title={title} placement="top">
                            {title}
                        </Tooltip>
                    </div>
                    { showMenu &&
                    <div className='jobadcard-icon'>
                        <Dropdown onClick={onClickDropdown}
                            menu={{ items, onClick: menuClicked }}
                            overlayClassName='jobadcard-dropdown-overlay'
                        >
                            <MoreOutlined />
                        </Dropdown>
                    </div>
                    }
                </Flex>
                <div className='jobad-card-subtitle'>
                    {subTitle}
                </div>
                <div className="jobad-card-date">
                    Last modified <b>{moment(date).format('LLL')}</b>
                </div>
            </div>
        </div>
    )

}

export default JobAdCard;
